import type { NessFrameProduct } from '../../../S/Constant/frame-product';

async function createCharacterNameTagCanvas(
  text: string,
  options: typeof NessFrameProduct.canvas_option.text,
): Promise<HTMLCanvasElement> {
  // DPR 정규화로 모든 디바이스에서 동일한 크기
  const { font_size, height, padding_left, padding_right, padding_top, padding_bottom, corner_margin } =
    options;

  const font = `${font_size}px ${options.font_family}`;

  const canvas = document.createElement('canvas');
  const ctx = canvas.getContext('2d');
  if (!ctx) throw new Error('Could not get canvas context');

  // 스케일된 폰트로 측정
  ctx.font = font;
  const metrics = ctx.measureText(text);

  canvas.width = metrics.width + padding_left + padding_right + corner_margin * 2;
  canvas.height = height + padding_top + padding_bottom;

  // 다시 폰트 설정
  ctx.font = font;
  ctx.imageSmoothingEnabled = false;
  ctx.textRendering = 'geometricPrecision';
  ctx.fontKerning = 'normal';

  // 배경 박스 그리기 (스케일된 좌표)
  ctx.fillStyle = options.background_color;
  ctx.fillRect(0, corner_margin, corner_margin, canvas.height - corner_margin * 2); // 왼쪽 세로
  ctx.fillRect(corner_margin, 0, canvas.width - corner_margin * 2, canvas.height); // 중앙
  ctx.fillRect(canvas.width - corner_margin, corner_margin, corner_margin, canvas.height - corner_margin * 2); // 오른쪽 세로

  // 텍스트 그리기 (스케일된 좌표)
  ctx.fillStyle = 'white';
  ctx.textBaseline = 'middle';
  ctx.fillText(text, padding_left + corner_margin, height / 2 + padding_top);
  return canvas;
}

function normalizeDprOptions(options: {
  font_family: string;
  font_size: number;
  background_color: string;
  height: number;
  padding_left: number;
  padding_right: number;
  padding_top: number;
  padding_bottom: number;
  corner_margin: number;
}) {
  const dpr = 2;
  return {
    font_family: options.font_family,
    font_size: options.font_size * dpr,
    background_color: options.background_color,
    height: options.height * dpr,
    padding_left: options.padding_left * dpr,
    padding_right: options.padding_right * dpr,
    padding_top: options.padding_top * dpr,
    padding_bottom: options.padding_bottom * dpr,
    corner_margin: options.corner_margin * dpr,
  };
}

export default createCharacterNameTagCanvas;
